import { schema } from 'normalizr';

export const orderImportSchema = new schema.Entity('orderImports', {}, { idAttribute: 'OrderImportId' });

export const orderImportListSchema = [orderImportSchema];
